import { useState } from 'react';
import styled from 'styled-components';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import { useAuthContext, setUser, logout } from '../contexts/AuthContext';
import { useHistory } from 'react-router';
import { login as masterLogin } from '../services/Master';
import { login as studentLogin } from '../services/Student';

const StyledButton = styled(Button)`
    margin-left: 16px;
`;

const Login = ({ master, referrer }) => {
    const history = useHistory();
    // const location = useLocation();
    // const referrer = location?.state?.from;

    const initialState = {
        token: '',
        isSubmitting: false,
        errorMessage: null,
    };
    const [data, setData] = useState(initialState);
    const { auth, dispatch } = useAuthContext();

    const handleInputChange = (event) => {
        setData({
            ...data,
            [event.target.name]: event.target.value,
        });
    };

    const handleFormSubmit = (event) => {
        // event.preventDefault();
        setData({
            ...data,
            isSubmitting: true,
            errorMessage: null,
        });
        const loginPromise = master
            ? masterLogin(data.token)
            : studentLogin(data.token);
        loginPromise
            .then((userData) => {
                setData((prev) => ({ ...prev, isSubmitting: false }));
                dispatch(setUser({ ...userData, token: data.token, master }));
                if (referrer) {
                    history.push(referrer);
                }
            })
            .catch((error) => {
                setData({
                    ...data,
                    isSubmitting: false,
                    errorMessage: error.message || error.statusText,
                });
            });
    };

    const handleLogout = () => {
        dispatch(logout());
    };

    if (auth.isAuthenticated) {
        return (
            <div>
                <p>You're logged in as: {auth.username}</p>
                <p>
                    <button onClick={handleLogout}>logout</button>
                </p>
            </div>
        );
    }

    return (
        <div>
            <form onSubmit={handleFormSubmit}>
                <h4>{master ? 'Master ' : 'Student '}login</h4>
                <TextField
                    id="token"
                    name="token"
                    label="Key"
                    variant="outlined"
                    value={data.token}
                    onChange={handleInputChange}
                />
                <StyledButton
                    variant="contained"
                    color="primary"
                    disabled={data.isSubmitting}
                    onClick={handleFormSubmit}
                >
                    {data.isSubmitting ? 'Loading...' : 'Login'}
                </StyledButton>

                {data.errorMessage && <div>{data.errorMessage}</div>}
            </form>
        </div>
    );
};

export default Login;
